module.exports = __webpack_public_path__ + "img/logo1.795db68d.png";